import React from 'react';
import TasksApp from '../Components/TimerApp/TasksApp';

const TimerApp = () => {
  return (
    <div>
      <TasksApp/>
    </div>
  )
}

export default TimerApp;